module.exports = __webpack_public_path__ + "img/1de9c35675eb9e8518c407becfa37c03.2b6cdfbb.png";